import { Address, AddressFormData } from '../types';

const convertAddress = (address: Address): AddressFormData => {
  return {
    Id: address.Id,
    Title: address.Title || '',
    TypeId: address.TypeId || null,
    TypeTitle: address.TypeTitle || '',
    Line1: address.Line1 || '',
    Line2: address.Line2 || ' ',
    City: address.City || 'Calgary',
    Province: address.Province || 'AB',
    PostalCode: address.PostalCode || '',
    Country: address.Country || 'Canada',
    CustomerId: address.CustomerId || null,
    PatrolType: address.PatrolType || '',
    Instructions: address.Instructions || 'Follow regular procedures.',
    OnlineMapUrl: address.OnlineMapUrl || '',
  };
};

export default convertAddress;
